import { Box, CircularProgress, Skeleton } from "@mui/material";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import FilterMaker from "../../components/FilterMaker/FilterMaker";
import TableV3 from "../../components/TableV3/TableV3";
import PendingApprovalTableConfig from "./PendingApprovalTableConfig";
import { useCallback, useEffect, useRef, useState } from "react";
import { PendingApprovalFilterConfig } from "./PendingApprovalFilterConfig";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Dropdown from "../../components/Input/Dropdown";
import { GTI_GET } from "../../util/newconfig";
import { useStateValue } from "../../util/stateProvider";
import advService from "../../util/advService";
import { AxiosResponse } from "axios";
import { JavaResponse } from "../../types";
import service from "../../util/axiosConfig";
import { HR_ACTIONS, HR_DOWNLOAD } from "../../util/config";
import { dateDifference, handleResponseAlert } from "../../util/functions";
import AdminActionModal from "../Admin/AdminActionModal";
import { changeDateFormat } from "../../util/date";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import {
    resetSelectedRows,
    resetSelectedRowsKeys,
    resetUnselectedRowsKeys,
    setAllSelected,
} from "../../features/table/tableStore";
import { fetchPolicyDetails } from "../../App";
import ModalContainer from "../../components/Modals/GenericModalContainer";
import Button from "../../components/Layout/Button";
import MyText from "../../components/Input/MyText";
import { Form, Formik } from "formik";
import * as Yup from "yup";

export default function PendingApproval() {
    const [loading, setLoading] = useState(false);
    const [{ adminMembers, uuid, user }, dispatch] = useStateValue();
    const { tableData } = useSelector(
        (state: RootState) => state.table["default"]
    );
    const reducerDispatch = useDispatch();
    const queryClient = useQueryClient();
    const filter = useSelector(
        (state: RootState) => state.table["default"].filter
    );
    const [actionModal, setActionModal] = useState<any>(false);
    const [selected, setSelected] = useState<any[]>([]);
    const [tableRefreshKey, setTableRefreshKey] = useState(0);
    const [filterConfig, setfilterConfig] = useState(
        PendingApprovalFilterConfig
    );
    const [memberUploadResponse, setMemberUploadResponse] = useState<any>({});
    const [loadingpolicyTypes, setLoadingpolicyTypes] = useState(false);
    const [policyTypes, setPolicyTypes] = useState<
        { id: string; name: string }[]
    >([]);
    const { policyDto } = useSelector((state: RootState) => state.home);
    const [pid, setPid] = useState<number | null>(null);

    useEffect(() => {
        if (uuid && pid) {
            setfilterConfig((prev) => {
                return {
                    ...prev,
                    url: `v1/employer/tasks/v2/list/hrPending/${uuid}/${pid}`,
                };
            });
        }
    }, [pid, uuid]);

    // Load policy types
    useEffect(() => {
        let config = { ...GTI_GET };
        config.url += `${uuid}`;
        setLoadingpolicyTypes(true);
        advService(config, {}, (res: AxiosResponse<JavaResponse<any>>) => {
            setMemberUploadResponse(res.data.response.memberUploadResponse);
        });
    }, [uuid]);

    const findPendingCount = (pid: number) => {
        if (pid) {
            const policy = policyDto?.d_home_policies?.find(
                (p: any) => p.pid === pid
            );
            return policy
                ? parseInt(
                      policy.homeDemographicDTO.hrApprovalPendingCount || 0
                  )
                : 0;
        }
        return 0;
    };

    useEffect(() => {
        if (memberUploadResponse && policyDto?.d_home_policies?.length > 0) {
            let temp = [];
            if (
                memberUploadResponse.gmcUploaded &&
                findPendingCount(memberUploadResponse.gmcPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gmcPId,
                    name: "GMC",
                });
            }
            if (
                memberUploadResponse.gpaUploaded &&
                findPendingCount(memberUploadResponse.gpaPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gpaPId,
                    name: "GPA",
                });
            }
            if (
                memberUploadResponse.gtlUploaded &&
                findPendingCount(memberUploadResponse.gtlPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gtlPId,
                    name: "GTL",
                });
            }
            if (
                memberUploadResponse.gcriticalIllnessUploaded &&
                findPendingCount(memberUploadResponse.gcriticalIllnessPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gcriticalIllnessPId,
                    name: "GCI",
                });
            }
            if (
                memberUploadResponse.copdUploaded &&
                findPendingCount(memberUploadResponse.copdPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.copdPId,
                    name: "COPD",
                });
            }
            if (
                memberUploadResponse.gtopUploaded &&
                findPendingCount(memberUploadResponse.gtopUpPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gtopUpPId,
                    name: "GTOPUP",
                });
            }
            if (
                memberUploadResponse.parentalUploaded &&
                findPendingCount(memberUploadResponse.parentalPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.parentalPId,
                    name: "PARENTAL",
                });
            }
            if (
                memberUploadResponse.enrollmentUploaded &&
                findPendingCount(memberUploadResponse.enrollmentPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.enrollmentPId,
                    name: "ENROLLMENT",
                });
            }
            if (
                memberUploadResponse.covidUploaded &&
                findPendingCount(memberUploadResponse.covidPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.covidPId,
                    name: "HEALTHCARE_WELLNESS",
                });
            }
            if (
                memberUploadResponse.parentalGtopUploaded &&
                findPendingCount(memberUploadResponse.parentalGtopUpPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.parentalGtopUpPId,
                    name: "PARENTALGTOPUP",
                });
            }
            if (
                memberUploadResponse.gtravelUploaded &&
                findPendingCount(memberUploadResponse.gtravelPId) > 0
            ) {
                temp.push({
                    id: memberUploadResponse.gtravelPId,
                    name: "GTRAVEL",
                });
            }

            setPolicyTypes(temp);
            setLoadingpolicyTypes(false);

            if (temp.length > 0) {
                setPid(temp[0].id);
            }
        }
    }, [memberUploadResponse, policyDto]);

    const handleRes = useCallback(
        (res: AxiosResponse<JavaResponse<any>>) => {
            if (res?.data?.success) {
                let value = res?.data?.response?.d_adminTask;
                for (let i = 0; i < value.length; i++) {
                    let temp = value[i];
                    if (temp.memberRequestLogs) {
                        let oldValue = "";
                        let currentValue = "";
                        for (
                            let j = 0;
                            j < temp.memberRequestLogs.length;
                            j++
                        ) {
                            oldValue += temp.memberRequestLogs[j]?.oldValue;
                            currentValue +=
                                temp.memberRequestLogs[j]?.currentValue;
                        }
                        temp.oldValue = oldValue;
                        temp.currentValue = currentValue;
                    }
                    if (temp.requestDate) {
                        temp.daysPast = Math.floor(
                            dateDifference(
                                changeDateFormat(
                                    "yyyy-mm-dd",
                                    "javascriptDateObject",
                                    temp.requestDate
                                ),
                                new Date()
                            )?.[0]
                        );
                    }
                    value[i] = temp;
                }
                dispatch({
                    type: "set-admin-members",
                    value: value,
                });
                setLoading(false);
            }
        },
        [dispatch]
    );

    const handleSubmit = (response: any) => {
        if (policyTypes && pid) {
            response.policyType = policyTypes.find(
                (val) => val.id == pid?.toString()
            )?.name;

            service.post_admin_action(
                HR_ACTIONS,
                actionModal?.action,
                uuid,
                actionModal?.selectedIds,
                policyTypes.find((val) => val.id == pid?.toString())?.name,
                policyTypes.find((val) => val.id == pid?.toString())?.id,
                {
                    ...response,
                    data: selected,
                    ...(actionModal?.payload?.batch && {
                        batch: actionModal?.payload?.batch,
                    }),
                    selectAll: actionModal?.payload.selectAll,
                    filter: filter,
                    uuid: uuid,
                    pid: policyTypes.find((val) => val.id == pid?.toString())
                        ?.id,
                    lead: JSON.parse(sessionStorage.getItem("lead") || "{}"),
                    policyData: policyDto?.d_home_policies?.find(
                        (policy: any) =>
                            policy.policyType ===
                            policyTypes.find((val) => val.id == pid?.toString())
                                ?.name
                    ),
                },

                (res: any) => {
                    handleRes(res);
                    fetchPolicyDetails(user, uuid, reducerDispatch, service);
                    queryClient.invalidateQueries(["homeData"]);
                    setTableRefreshKey((prev) => prev + 1);
                    reducerDispatch(resetSelectedRows({ tableId: "default" }));
                    reducerDispatch(
                        resetUnselectedRowsKeys({
                            tableId: "default",
                            // @ts-ignore
                            unselectedRowsKeys: [],
                        })
                    );
                    reducerDispatch(
                        setAllSelected({
                            tableId: "default",
                            allSelected: false,
                        })
                    );
                    reducerDispatch(
                        resetSelectedRowsKeys({ tableId: "default" })
                    );
                    setSelected([]);
                    setSelected([]);
                }
            );
            setActionModal(null);
        }
    };
    const downloadFunction = useCallback(
        (selected: any, selectionType?: string, unselectedRowKeys?: any) => {
            if (!pid || !policyTypes?.length) return;

            const policyTypeObj = policyTypes.find(
                (val: any) => val.id == pid?.toString()
            );
            if (!policyTypeObj) return;

            let updatedFilter = { ...filter };

            if (unselectedRowKeys?.length) {
                updatedFilter.f = [
                    ...updatedFilter.f,
                    { c: "uid", v: unselectedRowKeys, st: 5 },
                ];
            }

            service.post_admin_action(
                HR_ACTIONS,
                "HR_DOWNLOAD",
                uuid,
                [],
                policyTypeObj.name,
                policyTypeObj.id,
                {
                    data: selected,
                    ...(actionModal?.payload?.batch && {
                        batch: actionModal?.payload?.batch,
                    }),
                    selectAll: selectionType === "all" ? true : false,
                    filter: updatedFilter,
                    uuid: uuid,
                    pid: policyTypeObj.id,
                    lead: JSON.parse(sessionStorage.getItem("lead") || "{}"),
                    policyData: policyDto?.d_home_policies?.find(
                        (policy: any) =>
                            policy.policyType === policyTypeObj.name
                    ),
                },
                (res: any) => {
                    handleRes(res);
                    reducerDispatch(resetSelectedRows({ tableId: "default" }));
                    reducerDispatch(
                        resetUnselectedRowsKeys({
                            tableId: "default",
                            // @ts-ignore
                            unselectedRowsKeys: [],
                        })
                    );
                    reducerDispatch(
                        setAllSelected({
                            tableId: "default",
                            allSelected: false,
                        })
                    );
                    reducerDispatch(
                        resetSelectedRowsKeys({ tableId: "default" })
                    );
                    setSelected([]);
                }
            );
        },
        [uuid, pid, policyTypes, actionModal, policyDto, handleRes, filter]
    );

    const handleHrAction = useCallback(
        (data: any, payload: any, selectedRows: any[]) => {
            const selectedIds = selectedRows
                ?.map((item) => item?.uid)
                ?.toString();

            const modalPayload = {
                action: "",
                payload: payload,
                text: "",
                selectedIds: selectedIds,
            };
            if (payload?.hasOwnProperty("batch")) {
                modalPayload.text = "Insurer Data Tracker";
                modalPayload.action = "HR_APPROVE"; // HR_ gets removed in axiosConfig
            } else if (payload?.hasOwnProperty("reject")) {
                modalPayload.text = "Reject";
                modalPayload.action = "HR_REJECT"; // HR_ gets removed in axiosConfig
            }
            setSelected(selectedRows);
            setActionModal({ ...modalPayload });
        },
        []
    );

    const hrDownloadFunction = useCallback(
        (row: any, selectionType?: string) => {
            service.getDownload(
                `${HR_DOWNLOAD}/${uuid}/${row.uid}`,
                uuid + ".pdf",
                handleResponseAlert,
                true
            );
        },
        [uuid]
    );

    const sendHRDataFunction = useCallback(
        (row: any, selectionType?: string) => {
            const payload = {
                batch: true,
                button: "createBatch",
                selectAll: selectionType === "all" ? true : false,
                // filter: filter,
            };
            handleHrAction("", payload, row);
        },
        [handleHrAction]
    );

    const hrRejectFunction = useCallback(
        (row: any, selectionType?: string) => {
            const payload = {
                reject: true,
                selectAll: selectionType === "all" ? true : false,
                // filter: filter,
            };
            handleHrAction("", payload, row);
        },
        [handleHrAction]
    );

    const functions = {
        download: downloadFunction,
        hrDownload: hrDownloadFunction,
        hr_reject: hrRejectFunction,
        hr_approve: sendHRDataFunction,
    };
    return loading ? (
        <div className="progressbar-container">
            <CircularProgress
                color="primary"
                className="circularProgressCenter"
            />
        </div>
    ) : (
        <>
            <div
                className="top-metadata-container adminHeader"
                style={{ justifyContent: "space-between" }}
            >
                <h1 className="m0 normal noWrap" style={{ marginTop: "auto" }}>
                    Pending approvals
                </h1>
                <div className="logo_container">
                    <div
                        className="partner-logo"
                        style={{ height: 65, borderLeft: 0 }}
                    ></div>
                </div>

                <div
                    style={{
                        display: "flex",
                        marginTop: "auto",
                    }}
                >
                    {loadingpolicyTypes ? (
                        <Skeleton
                            variant="rounded"
                            style={{
                                width: 100,
                                height: 40,
                                borderRadius: 10,
                            }}
                            className="inverted topDropdown"
                        />
                    ) : (
                        policyTypes.length > 1 && (
                            <Dropdown
                                items={policyTypes}
                                defaultVal={policyTypes[0].id}
                                size="small"
                                change={(res: number) => setPid(res)}
                                className="inverted topDropdown"
                            />
                        )
                    )}
                </div>
            </div>
            <hr className="topSeperator" />
            <ErrorBoundary>
                <FilterMaker config={filterConfig} refreshKey={tableRefreshKey}>
                    <TableV3
                        config={PendingApprovalTableConfig}
                        data={tableData || []}
                        functions={functions}
                    />
                </FilterMaker>
            </ErrorBoundary>
            {actionModal && (
                <ModalContainer
                    close={() => {
                        setActionModal("");
                    }}
                    headingText={
                        actionModal?.payload?.hasOwnProperty("reject")
                            ? "Are you sure you want to reject selected members?"
                            : "Are you sure you want to approve selected members?"
                    }
                    input={true}
                >
                    <Formik
                        initialValues={{
                            ...actionModal?.payload,
                            batch: undefined,
                        }}
                        validationSchema={Yup.object({
                            ...(actionModal?.payload?.hasOwnProperty("reject")
                                ? {
                                      comment: Yup.string().required(
                                          "Comment is required"
                                      ),
                                  }
                                : {}),
                        })}
                        onSubmit={(values) => {
                            handleSubmit(values);
                        }}
                    >
                        <Form>
                            {actionModal?.payload?.hasOwnProperty("reject") && (
                                <div className="content ">
                                    <MyText
                                        label="Comment"
                                        name="comment"
                                        type="text"
                                        placeholder="Comment"
                                        onChange={() => {}}
                                    />
                                </div>
                            )}
                            <div className="buttons">
                                <Button
                                    loading={0}
                                    className="btn simple"
                                    onClick={() => setActionModal("")}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    loading={0}
                                    className="btn simple primary"
                                    type="submit"
                                >
                                    Confirm
                                </Button>
                            </div>
                        </Form>
                    </Formik>
                </ModalContainer>
            )}
        </>
    );
}
